import { JSONObject } from '../../types/types';
import { toFiniteNumber } from '../toFiniteNumber';

export type MatrixPlacement = {
  rows: number;
  columns: number;
  width: number;
  height: number;
  gapX: number;
  gapY: number;
  startX: number;
  startY: number;
};

// Normalizes the "generate matrix" dialog values into the grid placement —
// the single source of the placement math for building the grid
// (buildMatrixObjects) and for the overlap check against existing objects
// (getMatrixOverlappingObjects).
export const getMatrixPlacement = (
  matrixValues: JSONObject
): MatrixPlacement => {
  const rows = Math.max(1, Math.round(toFiniteNumber(matrixValues.rows, 1)));
  const columns = Math.max(
    1,
    Math.round(toFiniteNumber(matrixValues.columns, 1))
  );
  const width = Math.max(1, Math.round(toFiniteNumber(matrixValues.width, 1)));
  const height = Math.max(
    1,
    Math.round(toFiniteNumber(matrixValues.height, 1))
  );
  const gapX = Math.max(0, Math.round(toFiniteNumber(matrixValues.gapX, 0)));
  const gapY = Math.max(0, Math.round(toFiniteNumber(matrixValues.gapY, 0)));
  // indent = "Okraj": the whole matrix shifts one gap away from the start corner.
  const indent = matrixValues.indent === true;
  const startX =
    Math.round(toFiniteNumber(matrixValues.startX, 0)) + (indent ? gapX : 0);
  const startY =
    Math.round(toFiniteNumber(matrixValues.startY, 0)) + (indent ? gapY : 0);

  return { rows, columns, width, height, gapX, gapY, startX, startY };
};
